import { render, staticRenderFns } from "./AppComboComposeMessage.vue?vue&type=template&id=54fcb9ea&scoped=true"
import script from "./AppComboComposeMessage.vue?vue&type=script&lang=js"
export * from "./AppComboComposeMessage.vue?vue&type=script&lang=js"
import style0 from "./AppComboComposeMessage.vue?vue&type=style&index=0&id=54fcb9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fcb9ea",
  null
  
)

export default component.exports